function Directions(props) {
  return (
    <svg viewBox="0 0 15 15"
         fill={props.fill}
         height={props.height}
         width={props.width}
         {...props}>
      <path d="M0,8.8L15,0L7.4,15l-2-5.1L0,8.8z"/>
    </svg>
  );
}

Directions.defaultProps = {
  fill: 'currentColor',
  height: '1em',
  width: '1em',
}

export default Directions;
